import { State } from 'apprise-frontend-core/state/api';
import type { StackState } from 'apprise-ui/table/stacks';
import { createContext } from 'react';
import { TablesDataState, TablesState } from './provider';
import { ResizeSpec } from './resizing';




export const TableContext = createContext<State<TablesState>>(undefined!);

export const TableDataContext = createContext<State<TablesDataState>>(undefined!)

export const TableColumnResizeContext = createContext<State<ResizeSpec>>(undefined!);


export const initialStackState: StackState = {

    expandedRows: [],
    selectedStack: undefined

}

export const TableStackContext =  createContext<State<StackState>>(undefined!);